const stagingOrganizations = [
  { name: 'じょうづるさんPay', value: 'hitachiota-staging' },
  { name: 'むなかたPay', value: 'munakata-staging' },
  { name: 'AraoPAY', value: 'arao-staging' },
  { name: 'ちくちゃんペイ', value: 'chikuzen-staging' },
  { name: 'みやまスマイルペイ', value: 'miyama-staging' },
  { name: 'うきは市スマホ買い物券', value: 'ukiha-staging' },
  { name: '柳川藩Pay', value: 'yanagawa-staging' },
  { name: 'ふくつペイ', value: 'fukutsu-staging' },
  { name: 'いなＰＡＹ', value: 'inazawa-staging' },
  { name: '須恵町物価高騰支援電子商品券', value: 'machinowa-sue-staging' },
  { name: 'おおのジョーpay', value: 'oonojo-staging' },
  { name: 'すえPAY', value: 'sue-staging' },
  { name: 'くりみんpay', value: 'sasaguri-staging' },
  { name: 'CORDA環境ペイ', value: 'corda' },
  { name: 'かすやよかっPay', value: 'kasuya-staging' },
  { name: 'なかまPay', value: 'nakama-staging' },
  { name: 'まちのわふるさと納税アプリ', value: 'furusato-staging' },
  { name: 'Paycha', value: 'paycha-staging' },
  { name: 'いぐすペイ', value: 'sendai-staging' },
  { name: 'さいかいPay', value: 'saikai-staging' },
  { name: 'たけおPay', value: 'takeo-staging' },
  { name: '青森市生活応援商品券', value: 'aomori-staging' },
  { name: 'いぃ那珂PAY', value: 'naka-staging' },
  { name: '島田市くらし応援チケット', value: 'shimada-staging' },
  { name: 'かにPay', value: 'kanie-staging' },
  { name: '新城さくらpay', value: 'shinshiro-staging' },
  { name: 'いなぼうPay', value: 'inagawa-staging' },
  { name: 'SAGAプレミアムPay', value: 'sashoren-staging' },
  { name: 'タマにゃんPay', value: 'tamana-staging' },
  { name: '名古屋市プレミアム付き電子商品券', value: 'nagoya-staging' },
  { name: 'ひたpay', value: 'hita-staging' },
];

const productionOrganizations = [
  { name: 'じょうづるさんPay', value: 'hitachiota' },
  { name: 'むなかたPay', value: 'munakata' },
  { name: 'AraoPAY', value: 'arao' },
  { name: 'ちくちゃんペイ', value: 'chikuzen' },
  { name: 'みやまスマイルペイ', value: 'miyama' },
  { name: 'うきは市スマホ買い物券', value: 'ukiha' },
  { name: 'ふくつペイ', value: 'fukutsu' },
  { name: 'いなＰＡＹ', value: 'inazawa' },
  { name: '須恵町物価高騰支援電子商品券', value: 'machinowa-sue' },
  { name: 'すえPAY', value: 'sue' },
  { name: 'くりみんpay', value: 'sasaguri' },
  { name: 'かすやよかっPay', value: 'kasuya' },
  { name: 'なかまPay', value: 'nakama' },
  { name: 'まちのわふるさと納税アプリ', value: 'furusato' },
  { name: 'Paycha', value: 'paycha' },
  { name: 'いぐすペイ', value: 'sendai' },
  { name: 'さいかいPay', value: 'saikai' },
  { name: 'たけおPay', value: 'takeo' },
  { name: '青森市生活応援商品券', value: 'aomori' },
  { name: 'いぃ那珂PAY', value: 'naka' },
  { name: '島田市くらし応援チケット', value: 'shimada' },
  { name: 'かにPay', value: 'kanie' },
  { name: '新城さくらpay', value: 'shinshiro' },
  { name: 'いなぼうPay', value: 'inagawa' },
  { name: 'SAGAプレミアムPay', value: 'sashoren' },
  { name: 'ひたpay', value: 'hita' },
];

export { stagingOrganizations, productionOrganizations };
